

































































































































import {Vue, Component, Prop, Emit, Ref} from 'nuxt-property-decorator'
import moment from 'moment'
import { v4 as uuid } from 'uuid'
import Date from '@/directives/date'
import { Modal, SlidePanel, Tooltip } from '@frontend/components'
import Sortable from '@/directives/sortable'
import {warningNotification} from '@/notifications'
import { getBriefingThumbnail } from '../helpers'

@Component({
  components: {
    Modal,
    SlidePanel,
    Tooltip
  },
  directives: {
    Date,
    Sortable
  },
})
export default class TellimerBriefing extends Vue {

  @Prop({type: Object, required: true})
  layout: any

  @Prop({type: Boolean, default: false})
  highlightFields: boolean

  @Ref('slide-panel') readonly panel!: {show: any, hide: any}
  @Ref('modal-delete') readonly modal!: {show: any, hide: any}

  deleteItem: any | null = null

  asideType: string | null = null
  asideItem: any | null = null


  get items() {
    const localItems = [...this.layout.briefing.items]
    if (!localItems[0]?.sortOrder) {
      return localItems.map(item => ({
        ...item,
        id: uuid(),
        sortOrder: localItems.findIndex((i) => i.id == item.id) + 1,
      }))
    }
    return localItems
  }

  updateAsideContent(input) {
    getBriefingThumbnail(input, (err, post) => {
      if (err) {
        if (err) {
          this.$notify(warningNotification('I couldn\'t find an image and a summary based on the provided url, no image will be displayed for this item.'))
        }
        return
      }

      this.asideItem.image = post.url
      post?.article && (this.asideItem.article = post.article)
      this.asideItem.source = post.source
    })
  }

  @Emit('update')
  onItemsSort(sort) {
    const item = this.items[sort.oldIndex]
    const items = this.items.slice(0)
    items.splice(sort.oldIndex, 1)
    items.splice(sort.newIndex, 0, item)

    const itemsWithSortOrder = items.map(fi => ({...fi, sortOrder: items.findIndex((si) => si.id == fi.id) + 1}))

    return { briefing: { items: itemsWithSortOrder }}
  }

  showDeleteModal(item) {
    this.deleteItem = {...item}

    this.modal.show()
  }

  @Emit('update')
  confirmedDeleteItem() {
    const { items } = this

    items.splice(
      items.findIndex((item) => item.id == this.deleteItem.id),
      1
    )
    this.modal.hide()
    this.deleteItem = false
    const itemsWithSortOrder = items.map(fi => ({...fi, sortOrder: items.findIndex((si) => si.id == fi.id) + 1}))

    return { briefing: { items: itemsWithSortOrder }}
  }

  createItem() {
    this.asideType = 'create'

    this.asideItem = {
      id: uuid(),
      sortOrder: this.items.length + 1,
      link: '',
      summary: '',
      source: '',
      author: {
        name: this.$login.getUser().name,
        id: this.$login.getUser().id
      },
      image: null,
    }
    this.panel.show()
  }

  editItem(item) {
    this.asideType = 'edit'
    this.asideItem = {...item}
    this.panel.show()
  }

  cancelAside() {
    this.asideType = null
    this.asideItem = null
    this.panel.hide()
  }

  @Emit('update')
  confirmAside() {
    const { items, asideItem } = this
    if (this.asideType == 'create') {
      items.push({...this.asideItem, updated_at: moment().format()})
    }
    if (this.asideType == 'edit') {
      const asideItemIndex = items?.findIndex((item) => item.id == asideItem.id)
      items[asideItemIndex] = {
        ...asideItem,
        updated_at: moment().format(),
        author: {
          name: this.$login.getUser().name,
          id: this.$login.getUser().id
        },
      }
    }

    this.cancelAside()
    return { briefing: { items }}
  }

  deleteItemModalText() {
    if (!this.deleteItem) return 'deleteItem'
    let text = this.deleteItem.summary
    let arr = text.split(' ')
    let res = arr.splice(0, 15).join(' ')
    if (arr.length >= 15) res += ' ...'
    return `Are you sure you want to delete item: "${res}"? This cannot be undone.`
  }
}
